import axios from 'axios';
import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    
  },
  mutations: {

  },
  actions: {

    

    async login({ commit, dispatch }: any, authData: any) {
      let user;

      // Set loading state immediately for better UX
      commit('authen/loadingStatus', true, { root: true });

      // detect email and select original authen (password) or SSO
      authData.email = authData.email.toLowerCase()
      if(authData.email){
        const emailKey = authData.email.replace(/\./g, '||');

        const $emailKey = encodeURIComponent(emailKey);
        const url = `https://us-central1-people2-admin.cloudfunctions.net/getLoginData?email=${$emailKey}`;

        axios.post(url)
          .then(async (response) => {
            const data = _.get(response, "data");
            if (data && _.isObject(data)) {
              _.merge(authData, data);

              const user = _.get(authData, "user");
              const company = _.get(authData, "company");
              const isAdviser = !!(_.get(authData, "is_adviser") || _.get(user, "is_adviser"));

              // reset sso* from localStorage
              localStorage.removeItem('sso');
              localStorage.removeItem('sso_email');
              localStorage.removeItem('sso_provider_id');
              localStorage.removeItem('sso_logout_url');

              if (isAdviser) {
                // Adviser accounts always use PIN code and bypass company SSO.
                dispatch('authen/login', authData, { root: true });
              } else if (company) {
                const selectedSso = await dispatch('integrations/getSelectedSsoByEmail', authData.email, {root: true});
                const enabled = selectedSso && (selectedSso.hasOwnProperty('enabled') && selectedSso.enabled);
                if (enabled) {
                  authData.providerId = selectedSso.ssoProviderId;
                  localStorage.setItem('sso_email', authData.email);
                  localStorage.setItem('sso_provider_id', authData.providerId);
                  localStorage.setItem('sso_logout_url', selectedSso.ssoLogoutUrl);
                  dispatch('sso/show', authData, { root: true });
                } else {
                  dispatch('authen/login', authData, { root: true });
                }
              } else {
                commit('authen/loadingStatus', false, { root: true });
                dispatch('authen/clearError', null, { root: true });
                commit('authen/errorMessage', 'Please recheck your login credentials.', { root: true });
              }
            } else {
              commit('authen/loadingStatus', false, { root: true });
              dispatch('authen/clearError', null, { root: true });
              commit('authen/errorMessage', 'Please recheck your login credentials.', { root: true });
            }
          })
          .catch((error) => {
            // error: Please recheck your login credentials.
            dispatch('authen/login', authData, { root: true })
          });
      }
    },

    logout({ commit, dispatch }: any, payload: any) {
      const sso = localStorage.getItem('sso') == 'Y'
      let result = null
      if (sso) {
        result = dispatch('sso/logout', null, { root: true })
      }

      if (false !== result) {
        dispatch('authen/logout', payload || {}, { root: true })
      }
    }
  }
}
